// extracted by mini-css-extract-plugin
export default {"FormErrorsItem":"Form-module__FormErrorsItem--rPm5V"};